import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class AboutAwards  {
	constructor(elm) {
        this.elm = elm;

        this.tickerWrapper = this.elm.querySelector('[data-tickers]');
        this.tickers = this.elm.querySelectorAll('[data-ticker]');
		this.init();
	}

	init() {

        // Invert Trigger
        ScrollTrigger.create({
            trigger: this.elm,
            start: "top top",
            scrub: 1,
            onUpdate: self => {
                //('onUpdate Awards');
                if(self.progress>0) {
                    document.body.classList.add('body--inverted');
                } else {
                    document.body.classList.remove('body--inverted');
                }
            }
        });


        let mm = gsap.matchMedia();

        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)"
          }, (context) => {

            let { isDesktop, isMobile, reduceMotion } = context.conditions;

            if(reduceMotion) {
                return;
            }


            // Tickers
            const tickerTl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.tickerWrapper,
                    start: "top bottom",
                    end: 'bottom top',
                    scrub: 1
                },
            });

            tickerTl.to(this.tickers, {
                translateX: '0%',
                ease: 'none',
                duration: 1,
            });

        });

	}

}
